<template>
    <div v-if="popup">
        <span>{{ utils.euro(product.price) }}</span>
    </div>
    <div v-else class="mv_product">
        <div class="left">
            <div class="image-container mr-2" v-if="image">
                <img :src="image">
            </div>
            <div class="title">
                <div class="top">
                    <b>{{ product.name }}</b>
                </div>
                <div class="bottom">
                    <span v-html="product.description"></span>
                </div>
            </div>
        </div>
        <div class="details">
            <div class="d-flex justify-content-center align-items-center mv_variants_container"
                v-if="product.availableVariants.length > 0">
                <div class="text-center ml-3 mv_variant" v-for="v in product.availableVariants" :key="v.id">
                    <small class="text-muted text-uppercase variant-name"><b>{{ v.name }}</b></small>
                    <span>{{ utils.euro(v.price) }}</span>
                </div>
            </div>
            <span class="ml-3" v-else>{{ utils.euro(product.price) }}</span>
        </div>
    </div>
</template>

<script>
import utils from '@/utils'
export default {
    props: ["product", 'popup'],
    computed: {
        image() {
            let i = this.product.images.find(x => x.primary);
            if (!i) return undefined;
            return "/api/Image/Get/" + this.product.images.find(x => x.primary).id;
        }
    },
    methods: {
        addToCart() {
            return {};
        }
    },
    data() {
        return {
            utils
        }
    }
}
</script>

<style lang="scss">
.mv_product .bottom p {
    margin-bottom: 0;
}
</style>
<style lang="scss" scoped>

.left {
    display: flex;
    align-items: center;
}
.mv_product {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0.5em 0;
}

.image-container {
    width: 96px;
    height: 96px;
    display: flex;
    align-items: center;
    justify-content: center;

    img {
        width: 96px;
        height: 96px;
        object-fit: cover;
    }
}

.details {
    display: flex;
    flex-direction: column;
    justify-content: center;
}


</style>